var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info !== null)?_c('div',{staticClass:"bodys"},[_c('div',[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.info.title))])]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }